import React from 'react';
import propTypes from 'prop-types';

import LBwhite from './assets/LB-white.svg';
import LBblack from './assets/LB-black.svg';
import asterisk from './assets/asterisk.svg';

const LB = {
  dark: LBwhite,
  light: LBblack,
};

const Logo = ({ variant, width, height }) => {
  const containerStyle = {
    width: `${width}px`,
    height: `${height}px`,
    display: 'flex',
    pointerEvents: 'none',
  };

  const textStyle = {
    height: '100%',
  };

  // Currently the asterisk.svg has dimensions 49×50.
  // It should be perfect square, otherwise there are rotation glitches.
  const asteriskStyle = {
    height: `${Math.floor(height * 0.5)}px`,
    width: `${Math.floor(height * 0.5)}px`,
  };

  return (
    <div style={containerStyle}>
      <img src={LB[variant]} style={textStyle} alt="LB" />
      <img id="asterisk" src={asterisk} style={asteriskStyle} alt="*" />
    </div>
  );
};

Logo.propTypes = {
  variant: propTypes.oneOf(['light', 'dark']),
  width: propTypes.string,
  height: propTypes.string,
};
Logo.defaultProps = {
  variant: 'light',
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/index.js